module.exports = __webpack_public_path__ + "img/遺言書草案_PC.a4ae2543.png";